/**
 * @fileoverview gRPC-Web generated client stub for admpb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v0.0.0
// source: admpb/systemnumber.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_type_date_pb = require('../google/type/date_pb.js')
const proto = {};
proto.admpb = require('./systemnumber_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.admpb.SystemNumberServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.admpb.SystemNumberServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.admpb.SystemNumber,
 *   !proto.admpb.CreateSystemNumberResponse>}
 */
const methodDescriptor_SystemNumberService_CreateSystemNumber = new grpc.web.MethodDescriptor(
  '/admpb.SystemNumberService/CreateSystemNumber',
  grpc.web.MethodType.UNARY,
  proto.admpb.SystemNumber,
  proto.admpb.CreateSystemNumberResponse,
  /**
   * @param {!proto.admpb.SystemNumber} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.CreateSystemNumberResponse.deserializeBinary
);


/**
 * @param {!proto.admpb.SystemNumber} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.admpb.CreateSystemNumberResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.admpb.CreateSystemNumberResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.admpb.SystemNumberServiceClient.prototype.createSystemNumber =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/admpb.SystemNumberService/CreateSystemNumber',
      request,
      metadata || {},
      methodDescriptor_SystemNumberService_CreateSystemNumber,
      callback);
};


/**
 * @param {!proto.admpb.SystemNumber} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.admpb.CreateSystemNumberResponse>}
 *     Promise that resolves to the response
 */
proto.admpb.SystemNumberServicePromiseClient.prototype.createSystemNumber =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/admpb.SystemNumberService/CreateSystemNumber',
      request,
      metadata || {},
      methodDescriptor_SystemNumberService_CreateSystemNumber);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.admpb.SystemNumber,
 *   !proto.admpb.UpdateSystemNumberResponse>}
 */
const methodDescriptor_SystemNumberService_UpdateSystemNumber = new grpc.web.MethodDescriptor(
  '/admpb.SystemNumberService/UpdateSystemNumber',
  grpc.web.MethodType.UNARY,
  proto.admpb.SystemNumber,
  proto.admpb.UpdateSystemNumberResponse,
  /**
   * @param {!proto.admpb.SystemNumber} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.UpdateSystemNumberResponse.deserializeBinary
);


/**
 * @param {!proto.admpb.SystemNumber} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.admpb.UpdateSystemNumberResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.admpb.UpdateSystemNumberResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.admpb.SystemNumberServiceClient.prototype.updateSystemNumber =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/admpb.SystemNumberService/UpdateSystemNumber',
      request,
      metadata || {},
      methodDescriptor_SystemNumberService_UpdateSystemNumber,
      callback);
};


/**
 * @param {!proto.admpb.SystemNumber} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.admpb.UpdateSystemNumberResponse>}
 *     Promise that resolves to the response
 */
proto.admpb.SystemNumberServicePromiseClient.prototype.updateSystemNumber =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/admpb.SystemNumberService/UpdateSystemNumber',
      request,
      metadata || {},
      methodDescriptor_SystemNumberService_UpdateSystemNumber);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.admpb.ReadSystemNumberRequest,
 *   !proto.admpb.ReadSystemNumberResponse>}
 */
const methodDescriptor_SystemNumberService_ReadSystemNumber = new grpc.web.MethodDescriptor(
  '/admpb.SystemNumberService/ReadSystemNumber',
  grpc.web.MethodType.UNARY,
  proto.admpb.ReadSystemNumberRequest,
  proto.admpb.ReadSystemNumberResponse,
  /**
   * @param {!proto.admpb.ReadSystemNumberRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.ReadSystemNumberResponse.deserializeBinary
);


/**
 * @param {!proto.admpb.ReadSystemNumberRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.admpb.ReadSystemNumberResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.admpb.ReadSystemNumberResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.admpb.SystemNumberServiceClient.prototype.readSystemNumber =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/admpb.SystemNumberService/ReadSystemNumber',
      request,
      metadata || {},
      methodDescriptor_SystemNumberService_ReadSystemNumber,
      callback);
};


/**
 * @param {!proto.admpb.ReadSystemNumberRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.admpb.ReadSystemNumberResponse>}
 *     Promise that resolves to the response
 */
proto.admpb.SystemNumberServicePromiseClient.prototype.readSystemNumber =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/admpb.SystemNumberService/ReadSystemNumber',
      request,
      metadata || {},
      methodDescriptor_SystemNumberService_ReadSystemNumber);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.admpb.SystemNumber,
 *   !proto.admpb.ListSystemNumberResponse>}
 */
const methodDescriptor_SystemNumberService_ListSystemNumber = new grpc.web.MethodDescriptor(
  '/admpb.SystemNumberService/ListSystemNumber',
  grpc.web.MethodType.UNARY,
  proto.admpb.SystemNumber,
  proto.admpb.ListSystemNumberResponse,
  /**
   * @param {!proto.admpb.SystemNumber} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.ListSystemNumberResponse.deserializeBinary
);


/**
 * @param {!proto.admpb.SystemNumber} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.admpb.ListSystemNumberResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.admpb.ListSystemNumberResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.admpb.SystemNumberServiceClient.prototype.listSystemNumber =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/admpb.SystemNumberService/ListSystemNumber',
      request,
      metadata || {},
      methodDescriptor_SystemNumberService_ListSystemNumber,
      callback);
};


/**
 * @param {!proto.admpb.SystemNumber} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.admpb.ListSystemNumberResponse>}
 *     Promise that resolves to the response
 */
proto.admpb.SystemNumberServicePromiseClient.prototype.listSystemNumber =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/admpb.SystemNumberService/ListSystemNumber',
      request,
      metadata || {},
      methodDescriptor_SystemNumberService_ListSystemNumber);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.admpb.ListSystemNumberTypesRequest,
 *   !proto.admpb.ListSystemNumberTypesResponse>}
 */
const methodDescriptor_SystemNumberService_ListSystemNumberTypes = new grpc.web.MethodDescriptor(
  '/admpb.SystemNumberService/ListSystemNumberTypes',
  grpc.web.MethodType.UNARY,
  proto.admpb.ListSystemNumberTypesRequest,
  proto.admpb.ListSystemNumberTypesResponse,
  /**
   * @param {!proto.admpb.ListSystemNumberTypesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.ListSystemNumberTypesResponse.deserializeBinary
);


/**
 * @param {!proto.admpb.ListSystemNumberTypesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.admpb.ListSystemNumberTypesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.admpb.ListSystemNumberTypesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.admpb.SystemNumberServiceClient.prototype.listSystemNumberTypes =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/admpb.SystemNumberService/ListSystemNumberTypes',
      request,
      metadata || {},
      methodDescriptor_SystemNumberService_ListSystemNumberTypes,
      callback);
};


/**
 * @param {!proto.admpb.ListSystemNumberTypesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.admpb.ListSystemNumberTypesResponse>}
 *     Promise that resolves to the response
 */
proto.admpb.SystemNumberServicePromiseClient.prototype.listSystemNumberTypes =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/admpb.SystemNumberService/ListSystemNumberTypes',
      request,
      metadata || {},
      methodDescriptor_SystemNumberService_ListSystemNumberTypes);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.admpb.GetSystemNumberRequest,
 *   !proto.admpb.GetSystemNumberResponse>}
 */
const methodDescriptor_SystemNumberService_GetSystemNumber = new grpc.web.MethodDescriptor(
  '/admpb.SystemNumberService/GetSystemNumber',
  grpc.web.MethodType.UNARY,
  proto.admpb.GetSystemNumberRequest,
  proto.admpb.GetSystemNumberResponse,
  /**
   * @param {!proto.admpb.GetSystemNumberRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.GetSystemNumberResponse.deserializeBinary
);


/**
 * @param {!proto.admpb.GetSystemNumberRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.admpb.GetSystemNumberResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.admpb.GetSystemNumberResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.admpb.SystemNumberServiceClient.prototype.getSystemNumber =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/admpb.SystemNumberService/GetSystemNumber',
      request,
      metadata || {},
      methodDescriptor_SystemNumberService_GetSystemNumber,
      callback);
};


/**
 * @param {!proto.admpb.GetSystemNumberRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.admpb.GetSystemNumberResponse>}
 *     Promise that resolves to the response
 */
proto.admpb.SystemNumberServicePromiseClient.prototype.getSystemNumber =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/admpb.SystemNumberService/GetSystemNumber',
      request,
      metadata || {},
      methodDescriptor_SystemNumberService_GetSystemNumber);
};


module.exports = proto.admpb;

